import { Permission } from '@frontend/authorization';
import { Functionality } from '@frontend/functionality/types';
import { DefaultModalProps, useModals } from '@frontend/modal';
import { ReactNode, useCallback, useMemo } from 'react';

import { openApplicationCreate } from './open-application-create';

export interface ApplicationCreateWizardContext {
    functionality: Functionality;
    wizardId: string;
}

export interface UseApplicationCreateButtonProps {
    createPermissions: Permission[];
    modalId: string;
    renderDefaultModal: () => ReactNode;
    modalProps?: Record<string, unknown>;
    modalOptions?: Omit<DefaultModalProps, 'show' | 'handleClose'>;
    functionality?: Functionality | null;
    wizardId?: string | null;
}

export const useApplicationCreateButton = (props: UseApplicationCreateButtonProps) => {
    const { openModal } = useModals();
    const wizardContext = useMemo<ApplicationCreateWizardContext | null>(() => {
        if (!props.functionality || !props.wizardId) {
            return null;
        }
        return {
            functionality: props.functionality,
            wizardId: props.wizardId
        };
    }, [props.functionality, props.wizardId]);

    const onCreate = useCallback(() => {
        openApplicationCreate({
            openModal,
            modalId: props.modalId,
            renderDefaultModal: props.renderDefaultModal,
            modalProps: props.modalProps,
            modalOptions: props.modalOptions,
            wizardContext
        });
    }, [openModal, props.modalId, props.renderDefaultModal, props.modalProps, props.modalOptions, wizardContext]);

    return {
        onCreate,
        createPermissions: props.createPermissions,
        wizardContext
    };
};
